import React, { useState } from 'react';
import { Outlet, Navigate } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { Sidebar } from '../../components/vendor/Sidebar';
import { useAuth } from '../../components/auth/AuthContext';
export function VendorPortal() {
  const {
    user,
    isAuthenticated,
    isVendor
  } = useAuth();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  // Redirect if not authenticated or not a vendor
  if (!isAuthenticated || !isVendor) {
    return <Navigate to="/auth/vendor-login" replace data-id="element-2111" />;
  }
  return <div className="flex h-screen bg-gray-50" data-id="element-2112">
      {/* Desktop sidebar */}
      <div className="hidden md:flex md:flex-shrink-0" data-id="element-2113">
        <Sidebar data-id="element-2114" />
      </div>
      {/* Mobile sidebar */}
      {isMobileMenuOpen && <div className="fixed inset-0 z-40 md:hidden" data-id="element-2115">
          <div className="fixed inset-0 bg-gray-600 bg-opacity-75" onClick={() => setIsMobileMenuOpen(false)} data-id="element-2116"></div>
          <div className="relative flex flex-col w-full max-w-xs h-full bg-white" data-id="element-2117">
            <div className="absolute top-0 right-0 pt-2 pr-2" data-id="element-2118">
              <button className="ml-1 flex items-center justify-center h-10 w-10 rounded-full focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white" onClick={() => setIsMobileMenuOpen(false)} data-id="element-2119">
                <X className="h-6 w-6 text-gray-400" data-id="element-2120" />
              </button>
            </div>
            <Sidebar isMobile closeMobileMenu={() => setIsMobileMenuOpen(false)} data-id="element-2121" />
          </div>
        </div>}
      <div className="flex flex-col flex-1 overflow-hidden" data-id="element-2122">
        <header className="bg-white shadow-sm z-10" data-id="element-2123">
          <div className="px-4 sm:px-6 lg:px-8" data-id="element-2124">
            <div className="flex justify-between h-16" data-id="element-2125">
              <div className="flex items-center md:hidden" data-id="element-2126">
                <button type="button" className="inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none" onClick={() => setIsMobileMenuOpen(true)} data-id="element-2127">
                  <Menu className="h-6 w-6" data-id="element-2128" />
                </button>
              </div>
              <div className="flex items-center" data-id="element-2129">
                <h1 className="text-xl font-semibold text-gray-900" data-id="element-2130">
                  Welcome, {user?.companyName || user?.name}
                </h1>
              </div>
              <div className="flex items-center" data-id="element-2131">
                <div className="h-8 w-8 rounded-full bg-primary/10 flex items-center justify-center" data-id="element-2132">
                  <span className="text-primary font-medium" data-id="element-2133">
                    {user?.name.charAt(0).toUpperCase()}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </header>
        <main className="flex-1 overflow-y-auto p-4 sm:p-6 lg:p-8" data-id="element-2134">
          <Outlet data-id="element-2135" />
        </main>
      </div>
    </div>;
}